import { render, staticRenderFns } from "./OrderTypes.vue?vue&type=template&id=31f67720&scoped=true"
import script from "./OrderTypes.vue?vue&type=script&lang=js"
export * from "./OrderTypes.vue?vue&type=script&lang=js"
import style0 from "./OrderTypes.vue?vue&type=style&index=0&id=31f67720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f67720",
  null
  
)

export default component.exports